import $ from "jquery";

export const setup = (element, appRouter) => {
  element.on("click", "a[href]:not([data-bypass])", function (event) {
    // Get the absolute anchor href.
    const href = { prop: $(this).prop("href"), attr: $(this).attr("href") };
    // Get the absolute root.
    const root = location.protocol + "//" + location.host;

    // Ensure the root is part of the anchor href, meaning it's relative.
    if (href.prop.slice(0, root.length) === root) {
      // Stop the default event to ensure the link will not cause a page
      // refresh.
      event.preventDefault();
      event.stopPropagation();

      // `Backbone.history.navigate` is sufficient for all Routers and will
      // trigger the correct events. The Router's internal `navigate` method
      // calls this anyways.  The fragment is sliced from the root.
      appRouter.navigate(href.attr, { trigger: true });
    }
  });
};
